// eslint-disable-next-line import/no-cycle
import {
  selectionBasedLogicalOperators,
  numberLogicalOperators,
  dateStringLogicalOperators,
  dateNumberLogicalOperators,
} from '@/composables/segmentations/logicalOperators';
// eslint-disable-next-line import/no-cycle
import {
  getProductOrdersPropertiesSegments,
} from '@/composables/segmentations/themes/common-segments/productPropertiesSegment';
// eslint-disable-next-line import/no-cycle
import { fetchDataSources } from '@/composables/segmentations/helpers/fetchData';

/**
 * Get the cart properties segments
 * @param includeContext - If true, adds context property for dynamic evaluation
 */
const getCartPropertiesSegments = async (includeContext = false) => {
  const contextPrefix = includeContext ? 'cart.products' : undefined;
  const productProperties = await getProductOrdersPropertiesSegments(contextPrefix);
  const dataSources = await fetchDataSources();

  return [
    {
      id: 'amount',
      label: 'segmentations.hasDone.list.has_pending_cart.list.amount',
      logical_operators: numberLogicalOperators('amount'),
      hasCurrency: true,
      ...(includeContext && { context: 'cart.amount' }),
    },
    {
      id: 'products_in_cart',
      multiple: true,
      label: 'segmentations.hasDone.list.has_pending_cart.list.products_in_cart.label',
      sub_properties: productProperties,
    },
    {
      id: 'date',
      label: 'segmentations.hasDone.list.has_pending_cart.list.date',
      logical_operators: [
        {
          type: 'dateString',
          data: dateStringLogicalOperators('date'),
        },
        {
          type: 'dateNumber',
          data: dateNumberLogicalOperators('date'),
        },
      ],
    },
    ...(dataSources.length > 0 ? [{
      id: 'data_source',
      label: 'segmentations.hasDone.list.has_pending_cart.list.data_source',
      logical_operators: selectionBasedLogicalOperators('data_source', dataSources),
    }] : []),
  ];
};

export default getCartPropertiesSegments;
